<template>
  <div class="app-container">
    <div class="filter-container">
      <el-form ref="form" :model="listQuery" inline>
        <el-form-item prop="username">
          <el-input v-model="listQuery.username" placeholder="请输入用户账号" clearable @change="SearchData" @keyup.enter.native="SearchData" />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="SearchData">搜索</el-button>
        </el-form-item>
      </el-form>
    </div>
    <!--动作组-->
    <div class="action-container">
      <el-button-group>
        <!-- 弹窗层编辑 -->
        <el-button v-auth="'BankUser.create'" class="action-item" type="primary" icon="el-icon-plus" @click="HandleCreate">添加</el-button>
        <el-button v-auth="'BankUser.delete'" class="action-item" type="danger" icon="el-icon-delete" @click="BatchDelete">删除</el-button>
        <el-button class="action-item" type="success" icon="el-icon-back" @click="BatchBack">返回银行</el-button>
      </el-button-group>
    </div>
    <!--表开始-->
    <el-table ref="singleTable" v-loading="listLoading" :data="list" border fit highlight-current-row style="width: 100%" @sort-change="sortChange">
      <!--列开始-->
      <el-table-column type="selection" fixed></el-table-column>
      <!-- <el-table-column type="index" label="序号" width="55" :index="indexMethod" align="center" /> -->
      <el-table-column align="center" prop="username" show-overflow-tooltip label="用户账号"> </el-table-column>
      <el-table-column align="center" prop="realname" show-overflow-tooltip label="用户姓名"> </el-table-column>
      <el-table-column align="center" prop="status" show-overflow-tooltip label="状态">
        <template scope="scopes">
          <el-tag v-if="scopes.row.status==1" size="mini" type="success">启用</el-tag>
          <el-tag v-else size="mini" type="danger">禁用</el-tag>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="create_time" label="创建时间"> </el-table-column>
      <el-table-column fixed="right" align="center" prop="" label="操作" width="200" class-name="action">
        <template slot-scope="scopes">
          <el-button v-auth="'BankUser.update'" icon="el-icon-edit" type="primary" size="mini" @click="HandleUpdate(scopes.row)">编辑</el-button>
          <el-button v-auth="'BankUser.delete'" icon="el-icon-delete" type="danger" size="mini" @click="RowDelete(scopes.row)">删除</el-button>

        </template>
      </el-table-column>
      <!--列结束-->
    </el-table>
    <!--分页-->
    <pagination v-show="total>0" :total="total" :page.sync="listQuery.page" :limit.sync="listQuery.limit" @pagination="loadData" />
    <!--弹窗编辑/新增窗体-->
    <el-dialog :title="dialogStatus=='create'?'新增人员':'编辑人员'" :visible.sync="dialogFormVisible" width="40%">
      <el-form ref="dataForm" :rules="rules" :model="temp" label-position="left" label-width="110px" style="width: 100%;">
        <el-form-item label="用户账号" prop="username">
          <el-input v-model="temp.username" :disabled="dialogStatus != 'create'" placeholder="请输入用户账号" />
        </el-form-item>
        <el-form-item label="用户姓名" prop="realname">
          <el-input v-model="temp.realname" placeholder="请输入用户姓名" />
        </el-form-item>
        <el-form-item label="电话号码" prop="phone">
          <el-input v-model="temp.phone" placeholder="请输入电话号码" />
        </el-form-item>
        <el-form-item label="状态" prop="status">
          <el-radio v-model="temp.status" :label="1" border>
            启用
          </el-radio>
          <el-radio v-model="temp.status" :label="0" border>
            禁用
          </el-radio>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取消</el-button>
        <el-button type="primary" @click="ConfirmData">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import api from '@/api/bank_user' // 和数据交互相关写在api 方便复用
import Pagination from '@/components/Pagination' // 分页 给予 el-pagination 的二次封装
import commonList from '@/utils/commonList'
import WangEditor from '@/components/WangEditor'
import FileList from '@/components/attachment/FileList'
export default {
  name: 'BankUser',
  components: { Pagination, WangEditor, FileList },
  // 列绑定格式化器
  filters: {},
  mixins: [commonList],
  data() {
    var validatePhone = (rule, value, callback) => {
      const phonePattern = /^1[3-9]\d{9}$/
      if (!phonePattern.test(value)) {
        callback(new Error('请输入正确的手机号'))
      } else {
        callback()
      }
    }
    return {
      // api接口方法
      api,
      // 校验
      rules: {
        username: {
          required: true,
          message: '请输入用户账号',
          trigger: 'blur,change'
        },
        realname: {
          required: true,
          message: '请输入用户姓名',
          trigger: 'blur,change'
        },
        phone: {
          required: true,
          validator: validatePhone,
          trigger: 'blur,change'
        }
      },
      temp: {},
      listQuery: {
        page: 1,
        limit: 10, // 页大小
        order: 'DESC', // 默认排序方式,
        sort: 'id',
        bank_id: this.$route.query.bank_id
      },
      // 字典参数
      dictionary: [],
      // 字典参数
      // 表单锁
      lock: false
    }
  },
  created() {
    this.loadData()
    this.listQuery.bank_id = this.$route.query.bank_id
  },
  methods: {
    // 返回银行
    BatchBack() {
      this.$router.push({
        path: '/bank_info/branch_bank'
      })
    },
    ConfirmData() {
      if (this.lock == false) {
        this.lock = true
      }
      this.$refs['dataForm'].validate((valid) => {
        if (valid) {
          const formData = JSON.parse(JSON.stringify(this.temp))
          if (this.dialogStatus === 'create') {
            api
              .Create(formData)
              .then(() => {
                this.loadData()
                this.dialogFormVisible = false
                this.$notify({
                  title: '成功',
                  message: '操作成功',
                  type: 'success',
                  duration: 2000
                })
                setTimeout(() => {
                  this.lock = false
                }, 1000)
              })
              .catch((error) => {
                this.lock = false
              })
          } else {
            api
              .Update(formData)
              .then(() => {
                this.loadData()
                this.dialogFormVisible = false
                this.$notify({
                  title: '成功',
                  message: '操作成功',
                  type: 'success',
                  duration: 2000
                })
                setTimeout(() => {
                  this.lock = false
                }, 1000)
              })
              .catch((error) => {
                this.lock = false
              })
          }
        }
      })
    },
    resetTemp() {
      this.temp = {
        id: undefined,
        username: '',
        phone: '',
        status: 1,
        realname: '',
        bank_id: this.$route.query.bank_id
      }
    }
  }
}
</script>
<style scoped>
.el-tooltip__popper {
  max-width: 30%;
  padding-bottom: 5px !important;
  display: -webkit-box;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-line-clamp: 15;
  -webkit-box-orient: vertical;
}
.el-tooltip__popper,
.el-tooltip__popper.is-dark {
  background: rgb(48, 65, 86) !important;
  color: #fff !important;
  line-height: 24px;
}
</style>
